export default __webpack_public_path__ + "static/media/bxs-star_inactive.8625d7e6.svg";